import { Editor as TipTapEditor, getMarkRange } from "@tiptap/react";

import {
  Template,
  TemplateContentType,
} from "features/Influencer/ContactList/schema";

export const validateTemplateBody = (template: Template) => {
  let errorMessage = "";
  let isValidTemplate = true;
  if (!(template?.name?.trim()?.length > 0)) {
    errorMessage = "Please fill out template name";
    isValidTemplate = false;
  }
  if (!template.body || !(template?.body?.trim()?.length > 10)) {
    errorMessage = "Please fill out template body";
    isValidTemplate = false;
  }
  if (
    !(template?.subject?.trim()?.length > 5) &&
    template?.contentType === TemplateContentType.OUTREACH
  ) {
    errorMessage = "Please fill out template subject";
    isValidTemplate = false;
  }
  return {
    isValidTemplate,
    errorMessage,
  };
};

export const findHighlightRange = (
  editor: TipTapEditor,
  anchorText: string,
): { from: number; to: number } | null => {
  // Find the highlight mark in the editor's schema
  const highlightMark = editor.state.schema.marks.highlight;
  if (!highlightMark) return null;

  let match: { from: number; to: number } | null = null;
  editor.state.doc.descendants((node, pos) => {
    if (match) return false;
    if (!node.isText || !node.marks.some((m) => m.type === highlightMark)) {
      return true;
    }
    const range = getMarkRange(
      editor.state.doc.resolve(pos + 1),
      highlightMark,
    );
    if (range) {
      const text = editor.state.doc.textBetween(range.from, range.to);
      if (text === anchorText) {
        match = range;
        return false;
      }
    }
    return true;
  });

  return match;
};
